// declares WsImport action types.

import WsImportConst from '../constants/wsImport.constants';

// export const ShowComp          = (item) => {return {type: SHOW_COMP, value: item}};
// export const ImportFrom        = (item) => {return {type: IMPORT_FROM, value: item}};


export const ShowComp = item => ({
  type: WsImportConst.SHOW_COMP,
  value: item
});

export const ImportFrom = item => ({
  type: WsImportConst.IMPORT_FROM,
  value: item,
});

export const updateExternalApps = (externalApp, value) => ({
  type: WsImportConst.UPDATE_EXTERNAL_APP,
  externalApp,
  value,
});

export const itemToBeImport = items => ({
  type: WsImportConst.ITEM_TO_BE_IMPORT,
  items_to_be_import: items,
});

export const saveImportData = items => ({
  type: WsImportConst.SAVE_IMPORT_DATA,
  items,
});

export const saveRepositories = items => ({
  type: WsImportConst.GIT_REPOSITORIES_DATA,
  items,
});
export const saveRepositoriesError = items => ({
  type: WsImportConst.SAVE_REPOSITORIES_ERROR,
  items,
});
export const saveRepositoriesId = id => ({
  type: WsImportConst.SAVE_REPOSITORIES_DATA,
  items: id,
});
export const saveRepositoriesIds = (id, checked) => ({
  type: WsImportConst.SAVE_REPOSITORIES_MULTIPLE_DATA,
  items: id,
  checked,
});

export const saveProjectIds = (id, checked, empty = '', appType = '') => ({
  type: WsImportConst.SAVE_PROJECT_MULTIPLE_DATA,
  items: id,
  checked,
  empty,
  appType,
});

export const saveSyncTask = id => ({
  type: WsImportConst.SAVE_SYNC_TASK,
  items: id,
});


export const SetPorjectData = (items, type) => {
  console.log('SetPorjectData in action');
  return {
    type: WsImportConst.SET_PROJECT_DATA,
    items,
    projectType: type,
  };
};

export const SwitchBasicJql = externalApp =>
// console.log("SwitchBasicJql in action");
  ({
    type: WsImportConst.SWITCH_BASIC_JQL,
    externalApp,
  });

export const saveInstances = instances => ({
  type: WsImportConst.SAVE_INSTANCES,
  instances
})

export const setSelectedInstance = instance => ({
  type: WsImportConst.SET_SELECTED_INSTANCE,
  instance
})

export const setIsJql = isJql => ({
  type: WsImportConst.SET_IS_JQL,
  isJql
})

export const setWsName = wsName => ({
  type: WsImportConst.SET_WS_NAME,
  wsName
})